import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Retail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Retail </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      <b>The Future of AR and VR in Retail</b>
                      <br></br>
                        According to Forbes, the future of AR and VR in retail seems to break 
                        down into two major use categories. On one hand, AR lends itself well 
                        to consumer applications that answer questions such as, “What will it 
                        look like in my home? What will it look like on me? Tell me more about 
                        how to use this product.” VR, on the other hand, is finding a home in 
                        business uses such as store design, shelf assortment and layout, as well 
                        as in contextual store walks and real-time store performance, which allow 
                        executives to see store data in the context of how the store looks, rather 
                        than simply as a chart or list of numbers.
                        <br></br>
                        Consumers are excited about shopping’s tech-enabled future. Research by 
                        GfKfound 38 percent of U.S. consumers hope to see improved experiences in 
                        stores, while 35 percent want improved customer service based on individual 
                        needs, and another 35 percent seek improved ways to find and compare different 
                        products. With their ability to replace the parts shoppers dislike about 
                        shopping with a more immersive, interactive and information-fueled experience, 
                        AR and VR in retail holds promise to create the differentiated brand experiences 
                        that drive conversions, repeat visits and higher revenue.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Here are some examples of how retailers are already leveraging these 
                      technologies to do away with the things shoppers can’t stand, and 
                      replace them with better experiences.  
                      <br></br>
                      <b>a. Creating Virtual Encounters:</b> AR or VR can help overcome the hassle 
                      factor of shopping. Here’s one example: according to a McKinsey study, 
                      the average car buyer today visits 1.6 auto dealerships, down from five 
                      dealerships 10 years ago. Many call the experience boring, confrontational 
                      and bureaucratic, according to The Economist. But given how complicated 
                      cars are becoming, customers also want a knowledgeable person to talk them 
                      through all the features like entertainment systems, navigation services and 
                      automated parking. VR can bridge consumers’ seeming conflict between the desire 
                      for personal service and unwillingness to visit a store by enabling experiences 
                      virtually. For a car purchase, this might mean exploring the cockpit or 
                      taking a virtual test drive.
                      <br></br>
                      <b>b. Testing or Trying on Merchandise:</b> AR and VR can both be useful in helping 
                      consumers see products in context, such as a furniture buyer previewing how 
                      a couch would look in their living room. To overcome the stumbling block of 
                      consumers avoiding the possibility of overheated, poorly lit fitting rooms, 
                      Timberland unveiled a virtual fitting room using Kinect and digital signage 
                      technology that enables passersby to virtually try on every piece of clothing 
                      available in the store using hand gestures. Web and Facebook apps use a PC’s 
                      built-in cameras and AR to create a similar experience for home users.
                      <br></br>
                      <b>c. Create the Shopping Experience of the Future:</b>
                      <br></br>
                      1. Virtual Browsing: Online stores are well-organized, but less compelling 
                      and immersive than the experience of moving through a physical store. 
                      A VR-generated store lets customers virtually browse the store no matter 
                      where they are, and buy items they find — as Karen Miller did with a fashion 
                      showroom. Instead of the cost of erecting a brick and mortar location, the 
                      retailer simply designs 360-degree panoramas that are accessible on most 
                      platforms — including digital signage and smartphones.
                      <br></br>
                      2. Designing Custom Goods: Creating a custom order used to take a lot of 
                      time and rely on the customer’s imagination. AR and VR in retail help overcome 
                      those hurdles by producing virtual versions of the desired product. Nike’s Makers’ 
                      Experience combines AR, object tracking and projection technology (using AI and IoT) 
                      as well as digital signage or videowalls to enable a customized design to appear on 
                      sneakers. An hour later the customer can pick up the finished product.
                      <br></br>
                      3. Offering Product Info in Context: Lists of specs and features can be dry and 
                      mind-numbing. When such information is delivered in context, it makes a bigger 
                      impression: the shopper picks up and looks at a product, then sees specific 
                      information on the benefits of the part they’re viewing, so it’s much more likely 
                      to resonate. For instance, Starbucks is leveraging AR to blend the experiences of 
                      shopping in-store and online at its Starbucks Reserve Roasteryin Shanghai. Visitors 
                      can point their smartphones at a piece of equipment to see how coffee is processed in 
                      that machine to produce the product they’re considering.                  
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Retail templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Retail;



// WEBPACK FOOTER //
// ./src/views/Pages/Retail/Retail.js